/* eslint-disable jsx-a11y/href-no-hash */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getAuthToken } from '../../../../../reducers/auth';
import { getUserDetails } from '../../../../../reducers/userDetails';
import { geti18n } from '../../../../../reducers/i18n';
import {
  getContractsList,
  fireFetchPdfUrlForSignContract,
  setTemporalPdfUrl,
  areContractsLoading,
  allContractsSigned,
  fireFetchContracts,
  getNewUrl,
  getTemporalPdfUrl,
  fetchContractPdf,
  markContractAsSigned
} from '../../../../../reducers/contracts';
import { sendSignedAll } from '../../../../../services/backendService';
import ContractItem from './ContractItem';
import Button from '../../../../Button';
import Title from '../../../../Title';
import Spinner from '../../../../Spinner';
import Icon from '../../../../Icon';
import HelloSignIframeContainer from './HelloSignIframeContainer';

class Contracts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActiveIframe: false,
      currentContract: null,
      currentContractIndex: null,
      servicesCheckbox: false
    };
    this.openIframe = this.openIframe.bind(this);
    this.continue = this.continue.bind(this);
    this.closeIframe = this.closeIframe.bind(this);
    this.signCurrentContract = this.signCurrentContract.bind(this);
  }

  componentDidMount() {
    const id = this.props.userDetails.get('data').get('id');
    this.props.fireFetchContracts(id);
  }

  openIframe(i) {
    return () => {
      const contract = this.props.contracts.get(i);
      this.setState({
        isActiveIframe: true,
        currentContract: contract,
        currentContractIndex: i
      });
      const memberId = this.props.userDetails.get('data').get('id');
      this.props.fireFetchPdfUrlForSignContract(i);
      this.props.fetchContractPdf(i);
      this.props.getNewUrl(i, memberId);
    };
  }

  continue(event) {
    event.preventDefault();
    const id = this.props.userDetails.get('data').get('id');
    const allSigned = this.props.allContractsSigned;
    if (allSigned) {
      sendSignedAll(id, this.props.token);
      this.props.next();
    } else {
      console.warn('you need to sign all contracts');
    }
  }

  closeIframe() {
    this.props.setTemporalPdfUrl('');
    this.setState({
      isActiveIframe: false,
      currentContract: null,
      currentContractIndex: null
    });
  }

  signCurrentContract() {
    const { currentContractIndex } = this.state;
    this.props.markContractAsSigned(currentContractIndex, this.props.temporalPdfUrl);
    this.closeIframe();
  }

  renderIframeComponent() {
    const { isActiveIframe, currentContract } = this.state;
    return isActiveIframe ? (
      <HelloSignIframeContainer
        contractType={currentContract.get('contractType')}
        contractUrl={currentContract.get('contractURL')}
        close={this.closeIframe}
        sign={this.signCurrentContract}
      />
    ) : null;
  }

  render() {
    const i18n = this.props.i18n;
    const iframeComponent = this.renderIframeComponent();
    const loading = this.props.areContractsLoading ? <Spinner /> : null;
    const allSigned = this.props.allContractsSigned;
    const contractsFetch = this.props.contracts ? this.props.contracts : [];
    const iframeOrPdf = contractsFetch.map((contract, i) => <ContractItem key={i} contract={contract} notSignedFucntion={this.openIframe(i)} />);

    const contracts = iframeOrPdf.toArray();
    return (
      <div className="contracts">
        <Title text={i18n('onboarding.contracts.title')} className="form__title text-center pb-sm-5" />
        <form className="form" onSubmit={this.continue}>
          <div className="row justify-content-center mb-0 mb-5 pb-sm-5">
            <div className="contracts__contract_wrap">{contracts}</div>
          </div>
          <div className="text-initial mb-4 mb-sm-5 contracts__contract__service_checkbox">
            <input
              className="form__checkbox"
              id="membershipContract"
              type="checkbox"
              name="membershipContract"
              checked={this.state.servicesCheckbox}
              onChange={e => this.setState({ servicesCheckbox: !!e.target.checked })}
            />
            <label htmlFor="membershipContract" className="form__checkbox--fake">
              <Icon name="checkmark" />
            </label>
            <label className="form__label mb-0" htmlFor="membershipContract">
              {i18n('onboarding.contracts.iApprove')}{' '}
              <a className="" href="https://app-storage.venn.city/servicesContract.pdf" target="_blank" rel="noreferrer noopener">
                {i18n('onboarding.contracts.membershipContract')}
              </a>{' '}
              {i18n('onboarding.contracts.membershipContract2')}
            </label>
          </div>
          <div className="text-center">
            <Button text={i18n('onboarding.contracts.buttonText')} disabled={!allSigned || !this.state.servicesCheckbox} onClick={this.continue} />
          </div>
        </form>
        {iframeComponent}
        {loading}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userDetails: getUserDetails(state),
  contracts: getContractsList(state),
  allContractsSigned: allContractsSigned(state),
  areContractsLoading: areContractsLoading(state),
  temporalPdfUrl: getTemporalPdfUrl(state),
  token: getAuthToken(state),
  i18n: geti18n(state)
});

const actionMakers = {
  fireFetchPdfUrlForSignContract,
  fireFetchContracts,
  setTemporalPdfUrl,
  getNewUrl,
  fetchContractPdf,
  markContractAsSigned
};

export default connect(mapStateToProps, actionMakers)(Contracts);



// WEBPACK FOOTER //
// ./src/components/Views/Onboarding/Steps/Contracts/index.js